import React from "react";

/**
 * Steck Aviation wordmark—uses the official PNG brandmark (SA monogram
 * + "STECK AVIATION" wordmark in navy #002868 on white).
 *
 * Variants:
 *   "white" (default)—inverts the navy logo to white via CSS filter,
 *            for use on dark navy/black surfaces (navbar, vestibule, dark sections)
 *   "navy"           —renders the logo in its native navy, for use on
 *            light surfaces (print, future light pages)
 *
 * Source aspect ratio: 448 × 172 ≈ 2.605
 * `size` controls the *height* in pixels; width is computed proportionally.
 */
export const SteckLogo = ({ size = 40, variant = "white", className = "" }) => {
  const ratio = 448 / 172;
  const src = variant === "navy" ? "/steck-logo.png" : "/steck-logo-white-new.png";
  return (
    <img
      src={src}
      alt="Steck Aviation"
      width={Math.round(size * ratio)}
      height={size}
      style={{
        height: size,
        width: "auto",
        display: "block",
      }}
      className={className}
      draggable={false}
    />
  );
};

export default SteckLogo;
